import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { AuthUser } from '../../models/user.model';

export const AuthActions = createActionGroup({
  source: 'Auth',
  events: {
    Login: props<{ email: string; password: string }>(),
    'Login Success': props<{ user: AuthUser; token: string; refreshToken: string }>(),
    'Login Failure': props<{ error: string }>(),
    Logout: emptyProps(),
    Hydrate: props<{ user: AuthUser; token: string }>(),
    'Refresh Success': props<{ token: string; refreshToken: string }>(),

    'Update Profile': props<{ nombre: string; apellidoPaterno: string; apellidoMaterno?: string }>(),
    'Update Profile Success': props<{ user: AuthUser }>(),
    'Update Profile Failure': props<{ error: string }>(),
    'Clear Profile Save Success': emptyProps(),

    'Change Password': props<{ currentPassword: string; newPassword: string }>(),
    'Change Password Success': emptyProps(),
    'Change Password Failure': props<{ error: string }>(),
    'Clear Password Save Success': emptyProps(),
  },
});
